import { render } from "./S150531.vue?vue&type=template&id=153a8bae"
const script = {}
script.render = render

export default script